import {
    ACCOUNTS_INSTANCE,
    EVENTCHAIN_INSTANCE,
    ORGANIZATION_INSTANCE,
    PASS_ORDER_INSTANCE,
    PLACES_INSTANCE
} from "@/helper/consts";

import Breadcrumbs from "@/modules/entitled/Breadcrumbs";
import names from "@/modules/entitled/routers/names";
import OrdersBreadcrumbs from "@/modules/entitled/orders/OrdersBreadcrumbs";
import VisitorsBreadcrumbs from "@/modules/entitled/visitors/VisitorsBreadcrumbs";
import GuardBreadcrumbs from "@/modules/entitled/guard/GuardBreadcrumbs";
import OrdersDetail from "../orders/pages/Detail"
import OrdersLog from "../orders/pages/Log"
import VisitorsDetail from "../visitors/pages/Detail"
import ChatApprove from "@/modules/entitled/chat/ChatApprove";
import OrganizationsBreadcrumbs from "@/modules/entitled/organizations/OrganizationsBreadcrumbs";
import GuardPostsBreadcrumbs from "@/modules/entitled/guardposts/GuardPostsBreadcrumbs";
import GuardPostsDetail from "@/modules/entitled/guardposts/pages/Detail";
import OrdersFile from "@/modules/entitled/orders/pages/File";
import RegularFile from "@/modules/entitled/regularpasses/components/File";
import RegularPassesList from "@/modules/entitled/regularpasses/RegularPassesList.vue";
import BansList from "@/modules/entitled/bans/BansList.vue";
import FoulsList from "@/modules/entitled/fouls/FoulsList.vue";


export default ([
    {
        path: "/entitled",
        name: names.MAIN,
        component: Breadcrumbs,
        meta: {
            breadcrumb: "Согласующий",
            requiredAuth: true,
            instances: [
                PASS_ORDER_INSTANCE,
                ACCOUNTS_INSTANCE,
                EVENTCHAIN_INSTANCE
            ]
        },
        children: [
            {
                path: "orders",
                name: names.ORDERS.LIST,
                component: OrdersBreadcrumbs,
                meta: {
                    breadcrumb: "Заявки",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: "file/:idFile",
                        name: names.ORDERS.FILE,
                        component: OrdersFile,
                        meta: {
                            breadcrumb: "Файл",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    },
                    {
                        path: ":idOrders",
                        name: names.ORDERS.DETAIL,
                        component: OrdersDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    },
                    {
                        path: ":idOrders/log",
                        name: names.ORDERS.LOG,
                        component: OrdersLog,
                        meta: {
                            breadcrumb: "Журнал логирования",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "visitors",
                name: names.VISITORS.LIST,
                component: VisitorsBreadcrumbs,
                meta: {
                    breadcrumb: "Посетители",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idVisitors",
                        name: names.VISITORS.DETAIL,
                        component: VisitorsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]

            },
            // {
            //     path: 'guard_access',
            //     name: names.GUARD._BASE,
            //     component: GuardBreadcrumbs,
            //     meta: {
            //         breadcrumb: 'Доступ охраны',
            //         requiredAuth: true,
            //         instances: [
            //             PASS_ORDER_INSTANCE,
            //             ACCOUNTS_INSTANCE
            //         ]
            //     },
            //     children: [
            //     ]
            // },
            {
                path: "chat_approve",
                name: names.CHAT._BASE,
                component: ChatApprove,
                meta: {
                    breadcrumb: "Подтверждение чата",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                ]
            },
            {
                path: "organizations",
                name: names.ORGANIZATIONS.LIST,
                component: OrganizationsBreadcrumbs,
                meta: {
                    breadcrumb: "Организации",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "bans",
                name: names.BANS.LIST,
                component: BansList,
                meta: {
                    breadcrumb: "Заблокированные пользователи",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "fouls",
                name: names.FOULS.LIST,
                component: FoulsList,
                meta: {
                    breadcrumb: "Список нарушений",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "guardposts",
                name: names.GUARD_POSTS.LIST,
                component: GuardPostsBreadcrumbs,
                meta: {
                    breadcrumb: "Посты охраны",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idGuardPost",
                        name: names.GUARD_POSTS.DETAIL,
                        component: GuardPostsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "regularpasses",
                name: names.REGULAR_PASSES.LIST,
                component: RegularPassesList,
                meta: {
                    breadcrumb: "Список постоянных пропусков",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        PLACES_INSTANCE
                    ]
                },
                children: [
                    {
                        path: "file/:idFile",
                        name: names.REGULAR_PASSES.FILE,
                        component: RegularFile,
                        meta: {
                            breadcrumb: "Файл",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    }
                ]
            }
        ]
    }
])
